module.exports = __webpack_public_path__ + "img/icon-ranking-2@2x.7cc9dcaf.png";